import { Typography } from '@material-ui/core';

import menuItem from '../../menu-items';
import NavGroup from './NavGroup';
import customermgmt from '../../menu-items/customermgmt';
import settingsmgmt from '../../menu-items/settingsmgmt';
import adjudication from '../../menu-items/adjudication';
import accounts from '../../menu-items/accounts';
import membership from '../../menu-items/membership';
import branchUser from '../../menu-items/branchUser';
import other from '../../menu-items/other';
import managementdash from '../../menu-items/management';

const MenuList = () => {
  let navs = [];
  const userType = sessionStorage.getItem('dept');
  // 1 - Admin, 2 - Membership, 3 - Adjudication, 4 - Accounts
  if (userType === '1') {
    navs = [customermgmt, settingsmgmt];
  } else if (userType === '2') {
    navs = [membership];
  } else if (userType === '3') {
    navs = [adjudication];
  } else if (userType === '4') {
    navs = [accounts];
  } else if (userType === '5') {
    navs = [branchUser];
  } else if (userType === '6') {
    navs = [managementdash];
  } else {
    navs = [other];
  }

  const navItems = navs.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;

// import { Typography } from '@material-ui/core';

// import menuItem from '../../menu-items';
// import NavGroup from './NavGroup';

// const MenuList = () => {
//   const navItems = menuItem.items.map((item) => {
//     switch (item.type) {
//       case 'group':
//         return <NavGroup key={item.id} item={item} />;
//       default:
//         return (
//           <Typography key={item.id} variant="h6" color="error" align="center">
//             Menu Items Error
//           </Typography>
//         );
//     }
//   });

//   return <>{navItems}</>;
// };

// export default MenuList;
